import { isNullOrUndefined } from '@/utils/comparators'
import moment from 'moment'
import store from '@/store'
import {SUPPORTED_CULTURES, DEFAULT_LANGUAGE} from '@/utils/constants'
/**
* Receives an Array and returns a filtered Array with only unique values
* @param {Array} array
*/
const friendlyDate = (date) => {
  if (isNullOrUndefined(date) || date === '') {
    return '-'
  }
  return format(date, 'D MMMM YYYY')
}
/**
* Receives an Array and returns a filtered Array with only unique values
* @param {Array} array
*/
const formatedDateWithSlash = (date) => {
  if (isNullOrUndefined(date) || date === '') {
    return '-'
  }
  return format(date, 'MM/DD/YYYY')
}
/**
* Receives an Array and returns a filtered Array with only unique values
* @param {Array} array
*/
const format = (date, format) => {
  if (isNullOrUndefined(date) || date === '' ||
    isNullOrUndefined(format) || format === '') {
    return '-'
  }
  setLocaleToMoment()
  var formatedDate = moment(date)
  return formatedDate.format(format)
}

const monthYearFormat = (date) => {
  if (isNullOrUndefined(date) || date === '') {
    return '-'
  }
  setLocaleToMoment()
  return moment(date).format('MMMM, YYYY')
}

const diff = (a, b, unit) => {
  if (isNullOrUndefined(a) || a === '') {
    return '-'
  } else if (isNullOrUndefined(b) || b === '') {
    b = new Date()
  }

  if (isNullOrUndefined(unit) || unit === '') {
    unit = 'Days'
  }

  var aMoment = moment(a)
  var bMoment = moment(b)

  return (bMoment.diff(aMoment, unit) >= 0) ? bMoment.diff(aMoment, unit) : aMoment.diff(bMoment, unit)
}
const setLocaleToMoment = () => {
  let locale = store.getters['user/locale'] || DEFAULT_LANGUAGE
  let found = SUPPORTED_CULTURES.filter(a => a.twoLetter === locale)
  if (found.length > 0) {
    moment.locale(found[0].culture)
  }
}
const isCurrentDateBetween = (startAt, endAt) => {
  const currentDate = moment().toISOString()
  const dateIsAfter = moment(currentDate).isAfter(moment(startAt))
  const dateIsBefore = moment(currentDate).isBefore(moment(endAt))
  return dateIsAfter && dateIsBefore
}

export {
  format,
  friendlyDate,
  monthYearFormat,
  diff,
  formatedDateWithSlash,
  setLocaleToMoment,
  isCurrentDateBetween
}



// WEBPACK FOOTER //
// ./src/utils/date.js